import React, {useContext} from 'react';
import App from "./App";
import ToolbarPlaceholder from "./navigation/ToolbarPlaceholder";
import LogoNavigation from "./navigation/LogoNavigation";
import BroadcastInfo from "./navigation/BroadcastInfo";
import LinksNavigation from "./navigation/LinksNavigation";
import VisitorNavigation from "./navigation/VisitorNavigation";
import Footer from "./navigation/Footer";
import {AppContext} from "./AppContext";

class Layout extends React.Component {
    constructor(props) {
        super(props);
        this.setLayoutElement();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        /*if (this.props?.page === prevProps.page && this.props.context === prevProps.context) {
            return;
        }*/
        this.setLayoutElement();
    }

    setLayoutElement() {
        this.layoutElement = (
            <>
                <App />
                <ToolbarPlaceholder />
                <LogoNavigation/>
                <BroadcastInfo/>
                <LinksNavigation/>
                <VisitorNavigation/>
                {this.props?.page}
                <Footer/>
            </>
        );
    }

    render() {
        return this.layoutElement;
    }
}

const LayoutWithContext = (props) => {
    const context = useContext(AppContext);
    return (<Layout {...props} context={context} />);
};

export default LayoutWithContext;
